import { makeVar } from '@apollo/client'

import { DEFAULT_LOCATION } from '@/constants/location'
import { type Locale } from '@/generated'

export type GlobalLocation = {
  /**
   * Defines if maps is rendered with radius or points to an exact location
   */
  isRegion?: boolean
  /**
   * Defines locationId
   */
  id?: number
  /**
   * Defines initial selected latitude
   */
  latitude?: number | null
  /**
   * Defines initial selected longitude
   */
  longitude?: number | null
  /**
   * Location label - en / fr
   */
  name?: Locale
  /**
   * Defines postal code
   */
  postalCode?: string
  /**
   * Defines search radius
   */
  radius?: number
  /**
   * Defines street address
   */
  streetAddress?: string
}

/**
 * we need to provide an argument to makeVar, and an empty object
 * breaks the conditional logic in the SearchBar component
 */
export const searchLocationVar = makeVar<GlobalLocation>(DEFAULT_LOCATION)
